// extracted by mini-css-extract-plugin
export default {"overlay":"PreviewPanel_overlay__7v3pM","sheet":"PreviewPanel_sheet__J-GcU","wrapper":"PreviewPanel_wrapper__25+88"};